// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

function mapLocalStringToTypeLocale(val) {
  let match = val.toLowerCase();
  let exactMatch;
  switch (match) {
    case "ar" :
      exactMatch = "AR";
      break;
    case "bs" :
      exactMatch = "BS";
      break;
    case "ca" :
      exactMatch = "CA";
      break;
    case "cs" :
      exactMatch = "CS";
      break;
    case "cy" :
      exactMatch = "CY";
      break;
    case "da" :
      exactMatch = "DA";
      break;
    case "de" :
      exactMatch = "DE";
      break;
    case "el" :
      exactMatch = "EL";
      break;
    case "en" :
      exactMatch = "EN";
      break;
    case "en-gb" :
      exactMatch = "EN_GB";
      break;
    case "es" :
      exactMatch = "ES";
      break;
    case "et" :
      exactMatch = "ET";
      break;
    case "fi" :
      exactMatch = "FI";
      break;
    case "fr" :
      exactMatch = "FR";
      break;
    case "fr-be" :
      exactMatch = "FR_BE";
      break;
    case "fr-ca" :
      exactMatch = "FR_CA";
      break;
    case "he" :
      exactMatch = "HE";
      break;
    case "is" :
      exactMatch = "IS";
      break;
    case "it" :
      exactMatch = "IT";
      break;
    case "ja" :
      exactMatch = "JA";
      break;
    case "lt" :
      exactMatch = "LT";
      break;
    case "ms" :
      exactMatch = "MS";
      break;
    case "nb" :
      exactMatch = "NB";
      break;
    case "nl" :
      exactMatch = "NL";
      break;
    case "pl" :
      exactMatch = "PL";
      break;
    case "pt" :
      exactMatch = "PT";
      break;
    case "ru" :
      exactMatch = "RU";
      break;
    case "sk" :
      exactMatch = "SK";
      break;
    case "sv" :
      exactMatch = "SV";
      break;
    case "tr-cy" :
      exactMatch = "TR_CY";
      break;
    case "zh" :
      exactMatch = "ZH";
      break;
    case "zh-hant" :
      exactMatch = "ZH_HANT";
      break;
    default:
      exactMatch = undefined;
  }
  if (exactMatch !== undefined) {
    return exactMatch;
  }
  let baseLanguage = Core__Option.getOr(val.toLowerCase().split("-")[0], "");
  switch (baseLanguage) {
    case "ar" :
      return "AR";
    case "bs" :
      return "BS";
    case "ca" :
      return "CA";
    case "cs" :
      return "CS";
    case "cy" :
      return "CY";
    case "da" :
      return "DA";
    case "de" :
      return "DE";
    case "el" :
      return "EL";
    case "es" :
      return "ES";
    case "et" :
      return "ET";
    case "fi" :
      return "FI";
    case "fr" :
      return "FR";
    case "he" :
      return "HE";
    case "is" :
      return "IS";
    case "it" :
      return "IT";
    case "ja" :
      return "JA";
    case "lt" :
      return "LT";
    case "ms" :
      return "MS";
    case "nl" :
      return "NL";
    case "nb" :
    case "nn" :
    case "no" :
      return "NB";
    case "pl" :
      return "PL";
    case "pt" :
      return "PT";
    case "ru" :
      return "RU";
    case "sk" :
      return "SK";
    case "sv" :
      return "SV";
    case "tr" :
      return "TR_CY";
    case "zh" :
      return "ZH";
    default:
      return "EN";
  }
}

export {
  mapLocalStringToTypeLocale,
}
/* No side effect */
